import type { RequestInfo } from '@warp-drive/core/types/request';
import { buildBaseURL, type QueryUrlOptions } from '@warp-drive/utilities';
import { SkipCache } from '@warp-drive/core-types/request';

/**
 * Policy-chat init endpoints. Both speak `application/json` (not
 * vnd.api+json) so each builder sets Content-Type explicitly; the
 * auth handler's `setIfMissing` honors the override.
 *
 * The actual chat replies stream back over ActionCable
 * (`ChatChannel`); these requests just open the session — they don't
 * return the bot answer.
 */
const JSON_HEADERS = { 'Content-Type': 'application/json' };

export interface InitializeChatPayload {
  message: string;
  sessionId: string;
  requestId: string;
}

function chatInitUrl(resourcePath: string, id: string) {
  const opts: QueryUrlOptions = {
    identifier: { type: resourcePath },
    op: 'query',
    resourcePath,
  };
  return `${buildBaseURL(opts)}/${id}/chat`;
}

function chatInitRequest(url: string, payload: InitializeChatPayload): RequestInfo {
  return {
    url,
    method: 'POST',
    headers: new Headers(JSON_HEADERS),
    body: JSON.stringify({
      message: payload.message,
      session_id: payload.sessionId,
      request_id: payload.requestId,
    }),
    cacheOptions: { [SkipCache]: true },
  };
}

/** POST /partner-policies/:id/chat */
export function initializePolicyChatRequest(
  policyId: string,
  payload: InitializeChatPayload
): RequestInfo {
  return chatInitRequest(chatInitUrl('partner-policies', policyId), payload);
}

/** POST /tas-program-templates/:id/chat */
export function initializeTemplateChatRequest(
  templateId: string,
  payload: InitializeChatPayload
): RequestInfo {
  return chatInitRequest(chatInitUrl('tas-program-templates', templateId), payload);
}
